export const GET_HISTORY_START = 'GET_HISTORY_START'
export const GET_HISTORY_SUCCESS = 'GET_HISTORY_SUCCESS'
export const GET_HISTORY_FAIL = 'GET_HISTORY_FAIL'

export const CREATE_MESSAGE_START = 'CREATE_MESSAGE_START'
export const CREATE_MESSAGE_SUCCESS = 'CREATE_MESSAGE_SUCCESS'
export const CREATE_MESSAGE_FAIL = 'CREATE_MESSAGE_FAIL'

export const USER_NEW_MESSAGE = 'USER_NEW_MESSAGE'

export const GET_STATUSES_START_REPLY = 'GET_STATUSES_START_REPLY'
export const GET_STATUSES_SUCCESS_REPLY = 'GET_STATUSES_SUCCESS_REPLY'
export const GET_STATUSES_FAIL_REPLY = 'GET_STATUSES_FAIL_REPLY'

export const GET_STOPBOTEVENTS_START = 'GET_STOPBOTEVENTS_START'
export const GET_STOPBOTEVENTS_SUCCESS = 'GET_STOPBOTEVENTS_SUCCESS'
